import React, { useEffect } from 'react';
import '../styles/AboutPage.css';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  return (
    <div className="about-page">
      <header className="about-header text-center">
        <h1><span className='highlight'>About</span> Us</h1>
      </header>

      <main className="about-content">
        <div className="about-intro">
          <h2>Welcome to Mahadev Book – Where Trust Meets Technology:</h2>
          <p>
            Since its inception in 2010, <strong>Mahadev Book</strong> has grown into a leading name in the world of online gaming and sports exchange.
            We offer one of India’s most reliable and transparent platforms for sports enthusiasts and gaming lovers.
          </p>
          <p>
            Specializing in instant cricket IDs, secure transactions, and a seamless user experience, Mahadev Book is built on integrity and years of trust.
            We directly connect with our users via WhatsApp to ensure fast, efficient, and personalized service.
          </p>
        </div>

        <div className="about-who-we-are">
          <h2>Why Mahadev Book Stands Out:</h2>
          <ul>
            <li><strong>Trusted Since 2010:</strong> A decade of excellence with thousands of happy users.</li>
            <li><strong>24/7 Support:</strong> Get your cricket ID instantly with round-the-clock WhatsApp assistance.</li>
            <li><strong>Wide Game Variety:</strong> Cricket, Football, Teen Patti, Andar Bahar, and more.</li>
            <li><strong>200+ Branches:</strong> Nationwide offline support for added reliability.</li>
            <li><strong>Safe & Transparent:</strong> Secure deposits, quick withdrawals, and honest gameplay.</li>
          </ul>
        </div>

        <div className="about-trust">
          <h2>Our Mission:</h2>
          <p>
            At Mahadev Book, we aim to make online gaming accessible, fair, and fun for all. With a strong commitment to user security and innovation, we deliver an experience that’s rewarding, exciting, and transparent.
          </p>
        </div>

        <div className="about-join">
          <h2>Join the Mahadev Book Family:</h2>
          <p>
            Become part of a growing community that values trust and excitement. Whether you're a pro or just starting, Mahadev Book is your destination for reliable online gaming and betting.
          </p>
          <p>
            🔗 Contact us on WhatsApp @ 8888568888
          </p>
        </div>

        <div className="abt-btn">
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us @ 8888568888
          </a>
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            WhatsApp Us @ 8888988880
          </a>
        </div>
      </main>
    </div>
  );
};

export default AboutUs;
